const Calendar = ({ fill, size }: { fill?: string; size?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : "24"}
    height={size ? size : "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill ? fill : "#2c2c2c"}
      d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zm0-12H5V6h14zm-7 5h5v5h-5z"
    ></path>
  </svg>
);

export default Calendar;
